<template lang="pug">
    v-container.pb-md-5.width-100-percent.brown.lighten-5#message-dashboard-container(style="margin-top: 0px !important;" v-if="validBaseDashboardSummary && validDayDashboardSummary")
        
        MessageSoftphone.pa-2(
            v-if="validVmessage"
            v-bind:style="{ height: softphoneHeight + 'px' }"
            :account-id="conversationGroup.account_id"
            :customer-id="conversationGroup.customer_id"
            :customer-phone-number-id="conversationGroup.customer_phone_number_id"
            :exit="exitVmessage"
            :incoming-phone-number-id="conversationGroup.incoming_phone_number_id"
            :soft-phone-height="softphoneHeight"
        )

        div(v-show="!validVmessage")
            v-row
                v-col(cols="6")
                    Waiting(
                        :current-base-dashboard-summary="currentBaseDashboardSummary"
                        :dashboard-summary-conversation-groups="dashboardSummaryConversationGroups"
                        :open-vmessage="openVmessage"
                    )

                v-col(cols="6")
                    StatBoxes(
                        :current-day-dashboard-summary="currentDayDashboardSummary"
                    )

            //- v-row
            //-     v-col(cols="12")
            //-         MessagesGraph(
            //-             :current-day-dashboard-summary="currentDayDashboardSummary"
            //-             :hourly-dashboard-summaries="hourlyDashboardSummaries"
            //-         )

            v-row
                v-col(cols="12")
                    MessageScreen(
                        :agents="agents"
                        :current-base-dashboard-summary="currentBaseDashboardSummary"
                        :current-day-dashboard-summary="currentDayDashboardSummary"
                        :set-current-campaign-customer="setCurrentCampaignCustomer"
                    )

            //- v-row
            //-     v-col(cols="12")
            //-         Campaigns

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import Campaigns from '@/components/dashboards/live/message_dashboard/campaigns.vue';
    import MessagesGraph from '@/components/dashboards/live/message_dashboard/messages_graph.vue';
    import MessageScreen from '@/components/dashboards/live/tabs/messages_new.vue';
    import MessageSoftphone from '@/components/communication_center/sms_message/softphone.vue';
    import StatBoxes from '@/components/dashboards/live/message_dashboard/stat_boxes.vue';
    import Waiting from '@/components/dashboards/live/message_dashboard/waiting.vue';

    export default Vue.extend({
        data() {
            return {
                conversationGroup: {
                    account_id: null,
                    customer_id: null,
                    customer_phone_number_id: null,
                    incoming_phone_number_id: null,
                },
                isLoading: false,
                softphoneHeight: 600,
            }
        },
        methods: {
            exitVmessage() {
                this.conversationGroup = {
                    account_id: null,
                    customer_id: null,
                    customer_phone_number_id: null,
                    incoming_phone_number_id: null,
                }
            },
            handleSoftphoneHeight() {
                const containerTop = (document?.getElementById('message-dashboard-container')?.getBoundingClientRect()?.top || 0);
                if (containerTop > 0) {

                    const sofphoneHeight = window.innerHeight - containerTop - 40; // 40 coming from padding of container
                    this.softphoneHeight = sofphoneHeight;
                }
            },
            openVmessage(dashboardSummaryConversationGroup) {
                if (!dashboardSummaryConversationGroup) {
                    return;
                }

                // Set
                this.conversationGroup.account_id = dashboardSummaryConversationGroup.account_id;
                this.conversationGroup.customer_id = dashboardSummaryConversationGroup.customer_id;
                this.conversationGroup.customer_phone_number_id = dashboardSummaryConversationGroup.customer_phone_number_id;
                this.conversationGroup.incoming_phone_number_id = dashboardSummaryConversationGroup.incoming_phone_number_id;
            },
        },
        computed: {
            validBaseDashboardSummary() {
                return this.currentBaseDashboardSummary?.base_dashboard_summary?.id > 0;
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
            validVmessage() {
                return this.conversationGroup?.account_id > 0 && this.conversationGroup?.customer_id > 0 && this.conversationGroup?.customer_phone_number_id > 0 && this.conversationGroup?.incoming_phone_number_id > 0;
            },
        },
        components: {
            Campaigns,
            MessagesGraph,
            MessageScreen,
            MessageSoftphone,
            StatBoxes,
            Waiting,
        },
        props: {
            agents: Array,
            currentBaseDashboardSummary: Object,
            currentDayDashboardSummary: Object,
            dashboardSummaryConversationGroups: Array,
            hourlyDashboardSummaries: Array,
            setCurrentCampaignCustomer: Function,
        },
        watch: {
            validVmessage() {
                Vue.nextTick(() => {
                    this.handleSoftphoneHeight();
                });
            },
            isLoading() {
                Vue.nextTick(() => {
                    this.handleSoftphoneHeight();
                });
            },
        },
        created() {
            window.addEventListener('resize', this.handleSoftphoneHeight);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleSoftphoneHeight);
        },
        mounted() {
            setTimeout(() => {
                this.handleSoftphoneHeight();
            }, 500);
        },
    });
</script>

<style lang="scss" scoped>
</style>